var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPbView(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "pb-view_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 996",
    transform: "translate(1592 100)",
    fill: "#fff",
    stroke: "#707070",
    d: "M0 0h32v32H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1592 -100)",
    clipPath: "url(#pb-view_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11804",
    d: "M1619.573 115.57c-.211-.215-5.238-5.276-11.573-5.276s-11.363 5.058-11.574 5.276a.618.618 0 000 .865c.211.215 5.238 5.276 11.573 5.276s11.362-5.061 11.573-5.276a.618.618 0 00.001-.865zm-11.573 4.9c-4.768 0-8.881-3.274-10.226-4.473 1.343-1.2 5.448-4.472 10.226-4.472s8.881 3.274 10.226 4.473c-1.343 1.201-5.448 4.472-10.226 4.472z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11805",
    d: "M1603.925 115.996a4.074 4.074 0 104.07-4.07 4.079 4.079 0 00-4.07 4.07zm6.911 0a2.837 2.837 0 11-2.841-2.833 2.84 2.84 0 012.842 2.833z"
  }))));
}

export default __webpack_public_path__ + "21a3961ec11ba3e48df2f26ffc2feab5.svg";
export { SvgPbView as ReactComponent };